var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCounterCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41820_9127)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41820_9127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41820_9127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 12.5H14.375V18.75H13.125V12.5ZM13.75 5.625H11.25C10.1875 5.625 9.375 6.4375 9.375 7.5V11.875H10.625V7.5C10.625 7.125 10.875 6.875 11.25 6.875H13.75C14.125 6.875 14.375 7.125 14.375 7.5V11.875H15.625V7.5C15.625 6.4375 14.8125 5.625 13.75 5.625ZM10.625 18.75H11.875V12.5H10.625V18.75ZM10.625 3.125C10.625 2.0625 11.4375 1.25 12.5 1.25C13.5625 1.25 14.375 2.0625 14.375 3.125C14.375 4.1875 13.5625 5 12.5 5C11.4375 5 10.625 4.1875 10.625 3.125ZM11.875 3.125C11.875 3.5 12.125 3.75 12.5 3.75C12.875 3.75 13.125 3.5 13.125 3.125C13.125 2.75 12.875 2.5 12.5 2.5C12.125 2.5 11.875 2.75 11.875 3.125ZM6.875 6.25H4.375C3.3125 6.25 2.5 7.0625 2.5 8.125V9.375H3.75V8.125C3.75 7.75 4 7.5 4.375 7.5H6.875C7.25 7.5 7.5 7.75 7.5 8.125V9.375H8.75V8.125C8.75 7.0625 7.9375 6.25 6.875 6.25ZM3.75 3.75C3.75 2.6875 4.5625 1.875 5.625 1.875C6.6875 1.875 7.5 2.6875 7.5 3.75C7.5 4.8125 6.6875 5.625 5.625 5.625C4.5625 5.625 3.75 4.8125 3.75 3.75ZM5 3.75C5 4.125 5.25 4.375 5.625 4.375C6 4.375 6.25 4.125 6.25 3.75C6.25 3.375 6 3.125 5.625 3.125C5.25 3.125 5 3.375 5 3.75ZM17.5 10H16.25V11.25H17.5V18.75H18.75V11.25C18.75 10.5625 18.1875 10 17.5 10ZM2.5 10C1.8125 10 1.25 10.5625 1.25 11.25V18.75H2.5V11.25H3.75H8.75V10H3.75H2.5ZM5.625 15.5625L4.6875 14.625L4 15.3125L5.625 16.9375L8.4375 14.125L7.75 13.4375L5.625 15.5625Z",
    fill: "#BFA247"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41820_9127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCounterCheckin);
export default __webpack_public_path__ + "static/media/icon-counter-checkin.6510972081711abdf4254163624a5437.svg";
export { ForwardRef as ReactComponent };